import { render, staticRenderFns } from "./NewsEn.vue?vue&type=template&id=6f364576&"
import script from "./NewsEn.vue?vue&type=script&lang=js&"
export * from "./NewsEn.vue?vue&type=script&lang=js&"
import style0 from "./NewsEn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports